import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
} from '@mui/material';
import { SelectProps } from '@mui/material/Select';
import { useRef, useState } from 'react';

type ISelectBranded = SelectProps & {
  options: { value: string; label: string }[];
  label?: string;
  error?: boolean;
  helperText?: string;
};

export const SelectBranded = ({
  options,
  label,
  disabled,
  helperText,
  error,
  ...props
}: ISelectBranded) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const selectRef = useRef<HTMLInputElement>();

  return (
    <FormControl
      error={error}
      sx={{
        width: '100%',
        height: '58px',
        '& fieldset': {
          border: 'none',
        },
        '& .MuiSelect-select': {
          padding: '7px 32px 7px 14px',
        },
        '[data-shrink="true"]': {
          display: 'none',
          paddingTop: '20px !important',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        },
      }}
      onClick={() => setOpen(!isOpen)}
      disabled={disabled}
    >
      <InputLabel
        sx={{
          '[data-shrink="true"]': {
            paddingTop: '20px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
          },
          label: {
            '-webkit-text-fill-color': `rgba(0, 0, 0, 0.38)`,
          },
        }}
        disabled={disabled}
      >
        {label}
      </InputLabel>
      <Select
        {...props}
        inputRef={selectRef}
        sx={{
          borderRadius: 1,
          height: '58px',
          border: '1px solid',
          '& .MuiOutlinedInput-notchedOutline': {
            backgroundColor: 'transparent !important', // Prevents the background color change on hover
          },
        }}
        open={isOpen}
        MenuProps={{
          BackdropProps: {
            style: {
              opacity: 0,
            },
          },
        }}
        inputProps={props.inputProps}
        IconComponent={() =>
          isOpen ? (
            <KeyboardArrowUpIcon
              onClick={() => {
                selectRef.current?.blur();
                setOpen(false);
              }}
              sx={{ margin: 1, cursor: 'pointer' }}
            />
          ) : (
            <KeyboardArrowDownIcon
              onClick={() => {
                selectRef.current?.focus();
                setOpen(true);
              }}
              sx={{ margin: 1, cursor: 'pointer' }}
            />
          )
        }
      >
        {options.map((o) => (
          <MenuItem
            key={o.value}
            value={o.value}
            data-cy={`select-attribute-${o.value.replaceAll(' ', '-')}`}
          >
            {o.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
